const toSentence = array => {
  return array.length > 2
    ? array.slice(0, -1).join(', ') + ` ${I18n.t('and')} ` + array.slice(-1)
    : array.join(` ${I18n.t('and')} `);
};

export default toSentence;
